import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linejoin": "round",
      d: "M10.5 3.632a8.492 8.492 0 00-4.996 2.886L7.72 7.796A5.994 5.994 0 0110.5 6.19V3.632zM3.5 12c0-1.013.177-1.985.502-2.885l2.215 1.278A6.006 6.006 0 006 12c0 .556.076 1.095.217 1.607l-2.215 1.278A8.484 8.484 0 013.5 12zM5.504 17.482a8.492 8.492 0 004.996 2.886v-2.557a5.994 5.994 0 01-2.781-1.607l-2.215 1.278zM17.782 10.393a6.004 6.004 0 010 3.213l2.216 1.28c.325-.901.502-1.873.502-2.886a8.484 8.484 0 00-.502-2.885l-2.216 1.278zM18.496 6.518A8.491 8.491 0 0013.5 3.632v2.557a5.993 5.993 0 012.781 1.607l2.215-1.278zM13.5 17.811a5.993 5.993 0 002.781-1.607l2.215 1.278a8.491 8.491 0 01-4.996 2.886v-2.557z"
    })
  ]))
}